import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ApiService } from "../../components/API/ApiService"; 
import "../../styles/listeMur.css";
import FallingBricks from "../../components/fallingBricks"
import { useAuth } from "../../components/context/AuthContext";

function ListeMurs() {
  const { getApiBaseUrl } = useAuth();
  const [murs, setMurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const api = ApiService(getApiBaseUrl());

  useEffect(() => {
    api.getMurs()
      .then((data) => {
        setMurs(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur API :", error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Chargement des murs...</p>;
  }

  if (error) {
    return <p>Erreur lors du chargement : {error}</p>;
  }

  return (
    <div className="liste-murs-container">
      <FallingBricks />
      <h1>&#128203; Liste des Murs</h1>
      <ul className="liste-murs">
        {murs.map((mur) => (
          <li key={mur.id}>
            <Link to={`/MurDeBrique/${mur.id}`}>{mur.nom}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ListeMurs;